const settings = {
    mediaMaxPhone: 575,
    init(){
        this.textarea();
        this.selectSocial();
        this.avatarUpload.init();
        this.changeEmail.init();
        this.openUserDetails();
        this.mobileOpen();
        this.changeRequestStatus();
    },
    textarea(){
        const textarea = document.querySelector('[data-textarea]');
        if(textarea){
            textarea.addEventListener('input', ()=>{
                const btnUnlock = document.querySelectorAll('[data-button-unlock]');
                if(btnUnlock.length){
                    if(textarea.value.length){
                        btnUnlock.forEach(btn => {
                            if(btn.hasAttribute('disabled')){
                                btn.removeAttribute('disabled');
                            }
                        })
                    } else {
                        btnUnlock.forEach(btn => {
                            btn.setAttribute('disabled', true)
                        })
                    }
                }
            })
        }
    },
    selectSocial(){
        const selects = document.querySelectorAll('[data-select-container]');
        if(selects.length){
            selects.forEach(select => {
                const trigger = select.querySelector('[data-select-trigger]');
                const elements = select.querySelectorAll('[data-select-choice]');
                
                if(trigger){
                    trigger.addEventListener('click', ()=>{
                        // открытие окна
                        if(select.querySelector('[data-select-content]')?.classList.contains('hidden')){
                            select.querySelector('[data-select-content]').classList.remove('hidden');
                        } else {
                            select.querySelector('[data-select-content]')?.classList.add('hidden');
                        }  
                    })
                }

                if(elements.length){
                    elements.forEach(el => {
                        el.addEventListener('click', ()=>{
                            const choiceItem = el.cloneNode(true);
                            
                            select.querySelector('[data-select-choice]').replaceWith(choiceItem);
                            select.querySelector('[data-select-content]').classList.add('hidden');
                        })
                    })
                }

                select.addEventListener('click', (e)=>{
                    e.stopPropagation();
                })
                window.addEventListener('click', ()=>{
                    if(!select.querySelector('[data-select-content]')?.classList.contains('hidden')){
                        select.querySelector('[data-select-content]')?.classList.add('hidden');
                    }
                })

            })
        }
    },
    avatarUpload:{
        init(){
            this.deleteAvatar()
        },

        defaultImgPath: 'static/img/Vector.png',

        deleteAvatar(){
            const btnDelete = document.querySelector('[data-avatar-delete]');
            if(btnDelete){
                btnDelete.addEventListener('click', ()=>{
                    document.querySelector('[data-avatar]').src = this.defaultImgPath;
                })
            }

        }
    },
    changeEmail:{
        init(){
            // this.messageEmailChange();
        },
        changeEmailPause: false,
        // messageEmailChange(){
        //     const btnChange = document.querySelector('[data-button-change]');
        //     if(btnChange){
        //         const messageContainer = document.querySelector('[data-message-container]');
        //         const inputEmail = document.querySelector('[data-email]')
        //         btnChange.addEventListener('click', ()=>{
                    
        //             if(!this.changeEmailPause){
        //                 this.changeEmailPause = true;
        //                 const email = inputEmail.value;
        //                 if(email.includes('@') && email.includes('.')){
        //                     const message = document.createElement('div');
        //                     message.className = 'email-change d-flex flex-column';
        //                     message.innerHTML = `<div class="email-change-header fs-30 lh-120p c-neutral-100">Change e-mail </div>
        //                                                         <div class="email-change-body fs-20 lh-130p c-neutral-100">A confirmation of your mail change has been sent to your e-mail ${email}</div>`
        //                     messageContainer.append(message)
        //                     setTimeout(()=>{
        //                         message.remove();
        //                         this.changeEmailPause = false;
        //                     }, 5000)
        //                 }
        //             }

        //         })
        //     }
        // },
        sendMessage(heading, text, timeoutDuration){
            const messageContainer = document.querySelector('[data-message-container]');
            if(!this.changeEmailPause){
                console.log('mes')
                this.changeEmailPause = true;
                const message = document.createElement('div');
                message.className = 'email-change d-flex flex-column';
                message.innerHTML = `<div class="email-change-header fs-30 lh-120p c-neutral-100">${heading}</div>
                                                    <div class="email-change-body fs-20 lh-130p c-neutral-100">${text}</div>`
                messageContainer.append(message)
                setTimeout(()=>{
                    message.remove();
                    this.changeEmailPause = false;
                }, timeoutDuration)
            }
        }
    },
    openUserDetails(){
        const containers = document.querySelectorAll('[data-user-details-container]');
        if(containers.length){
            containers.forEach(container => {
                const btnOpen = container.querySelector('[data-user-details-button]');
                btnOpen.addEventListener('click', ()=>{
                    container.classList.toggle('active');
                })
            })
        }
        
    },
    mobileOpen(){
        const cards = document.querySelectorAll('[data-user-details-container-mobile]')
        if(cards.length){
            cards.forEach(card => {
                    card.addEventListener('click', ()=>{
                        if(card.classList.contains('mobile')){
                            card.classList.remove('mobile')
                        } else {
                            card.classList.add('mobile')
                            if(window.innerWidth <= this.mediaMaxPhone){
                                card.classList.remove('active')
                            }
                        }  
                    })
                    card.querySelector('[data-user-slide]').addEventListener('click', (e)=>{
                        e.stopPropagation();
                    })
                    card.querySelector('[data-user-details-container-down]').addEventListener('click', (e)=>{
                        e.stopPropagation();
                    })
            })
        }
    },
    changeRequestStatus(){
        const btns = document.querySelectorAll('[data-btn-confirm-payment]');
        if(btns.length){
            btns.forEach(btn => {
                btn.addEventListener('click', ()=>{
                    if(!btn.closest('.request').classList.contains('verified')){
                        btn.closest('.request').classList.add('verified')
                        btn.remove()
                    }
                })
            })
        }
    }
}

settings.init();
